/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// Added by Darragh C @ Shopify Theme Support August 15 2018

var sections = window.theme.sections;

var showLoadedVideo = {
  init: function() {

    // Assign 'variant_change' event handler
    this.on('slideshow_video_load', this._showVideoSlide.bind(this));
  },

  _showVideoSlide: function(event, instance, product, variant) {
    var self = this;
    setTimeout(function(){ 
      self.$slide.addClass('slideshow__video--loaded')
    }, 500)
  }

  
};

sections.extend('slideshow-section', showLoadedVideo);